export default {
  /**
   * Format number with thousand separator.
   * e.g 2500000 to "2.500.000"
   */
  number: (num: string | number | bigint | null) => {
    if (typeof num === 'string') {
      num = Number(num)
    }

    if (typeof num === 'number' || typeof num === 'bigint') {
      return new Intl.NumberFormat('id-ID').format(num)
    }

    return '0'
  },

  /**
   * Format number as percentage with decimal comma separator.
   * e.g 1.5 to "1,5%"
   */
  percent: (num: string | number | null | undefined) => {
    if (num === null || num === undefined || num === '') {
      return '-'
    }
    const val = Number(num)
    if (isNaN(val)) {
      return '-'
    }
    return new Intl.NumberFormat('id-ID', { maximumFractionDigits: 2 }).format(val) + '%'
  },
}
